module.exports = __webpack_public_path__ + "static/media/Araquanid_gaussian2.b6ec6dee.png";